module.exports = __webpack_public_path__ + "img/viet-nam.7a64ad2f.svg";